module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Comment Settings</span></div>\r\n<div class=\"row\">\r\n	<div class=\"col-md-12 nopadding-r\">\r\n		<textarea  name=\"text\" style=\"height: 100px; width: 100%;\">")
    ; __append(escapeFn( text ))
    ; __append("</textarea>\r\n	</div>\r\n</div>\r\n\r\n\r\n\r\n")
  }
  return __output;

}